import type { ReactElement } from 'react';
import { round } from 'utils/numbers';
import Cart from 'models/Cart';
import Alert from '../Alert';

type Props = { cart: Cart; };

function MinimumPriceAlert({ cart }: Props): ReactElement {
  const { subtotalPrice } = cart;
  const { minimum_base_price: minPrice } = cart.validations;
  const remainingValue = round(minPrice - subtotalPrice);

  return (
  // @ts-expect-error TODO: fix null safety
    <Alert type={cart.alert.type} heapEvent={cart.alert.heapEvent}>
      <strong>{`$${minPrice} `}</strong>
      min. Add
      <strong>{` $${remainingValue} `}</strong>
      to complete order.
    </Alert>
  );
}

export default MinimumPriceAlert;
